import React, { useState, useEffect } from "react";
import { Input, Button, message, Typography } from "antd";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // i18n hook

const { Title, Paragraph } = Typography;

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState(""); // Confirm password state
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const email = location.state?.email;

  useEffect(() => {
    if (!email) {
      navigate("/forgot-password");
    }
  }, []);

  const handleReset = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/Suppliers/email/${email}`);
      const supplierId = response.data.supplierId;

      await axios.patch(`${apiUrl}/api/Suppliers/ResetPassword`, {
        supplierId,
        newPassword,
      });

      message.success(t('reset_password_success'));
      navigate("/supplier-login");
    } catch (error) {
      message.error(t('reset_password_error'));
    }
  };

  const isButtonDisabled = newPassword.length < 8 || newPassword !== confirmPassword;

  return (
    <div style={pageStyle}>
      <div style={formStyle}>
        <Title level={3}>{t('reset_password_title')}</Title>
        <Paragraph>{t('reset_password_description')}</Paragraph>

        <Input.Password
          placeholder={t('reset_password_placeholder')}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          style={{ marginBottom: 16 }}
        />

        <Input.Password
          placeholder={t('confirm_password_placeholder')}  // Confirm password placeholder
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          style={{ marginBottom: 16 }}
        />

        {newPassword && confirmPassword && newPassword !== confirmPassword && (
          <Paragraph type="danger" style={{ color: 'red' }}>
            {t('passwords_do_not_match')}
          </Paragraph>
        )}

        <Button type="primary" block onClick={handleReset} disabled={isButtonDisabled}>
          {t('reset_password_button')}
        </Button>
      </div>
    </div>
  );
};

export default ResetPassword;

const pageStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  backgroundColor: "#f5f5f5",
};

const formStyle = {
  width: "100%",
  maxWidth: "400px",
  padding: "32px",
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
};
